<template>
    <div class="vuetable-filterbar col-md-12">
	    <div class="form-group p-l">
            <b-container fluid class="p-a-0">
                <b-row no-gutters>
                    <!-- <b-col sm="6" md="2" class="m-t-5px p-a-0">
                        <multiselect v-model="tp_unidade"
                        :options="optionsTipoUnidade"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Cliente"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col> -->

                    <b-col sm="6" md="2" class="m-t-5px p-a-0">
                        <multiselect v-model="tp_doc"
                        :options="this.$parent.optionsTpDoc"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Tipo do documento"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>

                    <b-col sm="6" md="4" class="m-t-5px p-a-0">
                        <multiselect
                        v-model="transportadora"
                        :options-limit="300"
                        :limit="2"
                        :limit-text="limitText"
                        :options="optionsTransportadora"
                        track-by="value"
                        label="label"
                        id="transportadora"
                        :hide-selected="true"
                        placeholder="Transportadora ( Digite 3 caracteres para pesquisar )"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        :searchable="true"
                        :loading="isLoadingTransportadora"
                        @search-change="listaTransportadora"
                        ></multiselect>
                    </b-col>
                    <b-col sm="6" md="2" class="m-t-5px p-a-0">
                     <b-form-datepicker
                        locale="pt-br"  
                        reset-button
                        placeholder="Data Inicial" 
                        v-model="dt_emissao_ini" 
                        class="form-control" 
                        :date-format-options="{day: 'numeric', month: 'numeric', year: 'numeric' }">
                        </b-form-datepicker>
                    </b-col>
                    <b-col sm="6" md="2" class="m-t-5px p-a-0">
                     <b-form-datepicker
                        locale="pt-br"
                        reset-button  
                        placeholder="Data Final" 
                        v-model="dt_emissao_fim" 
                        class="form-control" 
                        :date-format-options="{day: 'numeric', month: 'numeric', year: 'numeric' }">
                        </b-form-datepicker>
                    </b-col>
                    <b-col sm="6" md="2" class="m-t-5px">
                      <div class="input-group-btn">
                        <div class="btn-group">
                          <button type="button" class="btn btn-secondary btn-outline" @click="doFilter" :disabled="vuetableFilterButton">Filtrar</button>
                          <button type="button" class="btn btn-secondary btn-outline" @click="resetFilter" :disabled="vuetableFilterButton">Limpar</button>
                        </div>
                      </div>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
export default {
  data () {
    return {
    isLoadingTransportadora: false,
    transportadora: [],
    optionsTransportadora: [],
    data_filter: [],
    tp_doc: '',
    dt_emissao_ini: '',
    dt_emissao_fim: '',
    helpForm: new Form({statusRecord: [], params: [], search: "",}),
    }
  },
  methods: {
      doFilter () {
          this.$store.commit('setVuetableFilterButton', true);
          this.data_filter = {tp_doc: this.tp_doc,
                            transportadora: this.transportadora,
                            dt_emissao_ini: this.formatDateSubmit(this.dt_emissao_ini),
                            dt_emissao_fim: this.formatDateSubmit(this.dt_emissao_fim),}
          this.$events.fire('filter-set', this.data_filter);
      },
      resetFilter () {
        this.tp_doc = "";
        this.transportadora = "";
        this.dt_emissao_ini = "";
        this.dt_emissao_fim = "";
        this.$events.fire('filter-reset');
      },
      formatDateSubmit (value, fmt = 'DD/MM/YYYY') {
        return (value == null || value == "")
            ? ''
            : moment(value, 'YYYY/MM/DD HH:mm').format(fmt)
      },
        listaTransportadora(search) {
        if (search.length >= 3) {
            this.isLoadingTransportadora = true;
            this.helpForm.search = search;
            this.helpForm.status = 1;
            this.helpForm
            .post("/api/pessoa/jsonlist/transportadora")
            .then((response) => {
                this.optionsTransportadora = [];
                new ReturnApi(response, this, true, false, false);
                if (response.items.length > 0) {
                response.items.forEach((obj) => {
                    this.optionsTransportadora.push({
                    label: "PJ -" + obj.pessoa.cd + " - " + obj.razao_social + " - " + this.onFormataCnpj( obj.cnpj_base, obj.cnpj_filial, obj.cnpj_digito).replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5") + " - " + obj.inscricao_estadual, pessoa_id: obj.pessoa_id, value: obj.pessoa_id,
                    });
                });
                }
                if (response.itemsF.length > 0) {
                response.itemsF.forEach((obj) => {
                    this.optionsTransportadora.push({
                    label: "PF -" + obj.nome + " - " + obj.cpf,
                    pessoa_id: obj.pessoa_id,
                    value: obj.pessoa_id,
                    });
                });
                }
                if (response.itemsE.length > 0) {
                response.itemsE.forEach((obj) => {
                    this.optionsTransportadora.push({
                    label: "PE -" + obj.nome + " - " + obj.cd,
                    pessoa_id: obj.pessoa_id,
                    value: obj.pessoa_id,
                    });
                });
                }
                this.isLoadingTransportadora = false;
            })
            .catch((errors) => {
                new ReturnApi(errors, this);
            });
        }
    },
    onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
        var cnpj_formatado
        var pad = "00000000";
        var cnpj_base = pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
        var pad = "0000"
        var cnpj_filial = pad.substring(0, pad.length - cnpj_filial.toString().length) + cnpj_filial;
        var pad = "00"
        var cnpj_digito = pad.substring(0, pad.length - cnpj_digito.toString().length) + cnpj_digito;
        return cnpj_base + "" + cnpj_filial + "" + cnpj_digito;
    },
    limitText(count) {
      return " e ${count} outros clientes";
    },
  },
  computed: {
      vuetableFilterButton: {
          get () {
              return this.$store.state.vuetable.filterButton;
          },
      },
  }
}
</script>
